import { APP_LOGO, APP_TITLE } from "@/const";
import { trpc } from "@/lib/trpc";

type BrandLogoProps = {
  className?: string;
  size?: number;
  rounded?: boolean;
  showName?: boolean;
};

export function BrandLogo({ className = "", size = 32, rounded = true, showName = false }: BrandLogoProps) {
  // Use system icon (favicon) for brand logo throughout the app
  const { data: iconData } = trpc.settings.getSystemIcon.useQuery(undefined, { staleTime: 60_000, refetchOnWindowFocus: false });
  const { data: systemNameData } = trpc.settings.getPublicSystemName.useQuery(undefined, { staleTime: 60_000, refetchOnWindowFocus: false });
  
  const logoUrl = iconData?.url || APP_LOGO;
  const systemName = systemNameData?.systemName || "Okulus";
  
  if (showName) {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <img
          src={logoUrl}
          alt={systemName}
          className={`${rounded ? "rounded-md" : ""} object-cover ring-1 ring-border`}
          style={{ height: size, width: size }}
        />
        <span className="text-xl font-semibold">{systemName}</span>
      </div>
    );
  }
  
  return (
    <img
      src={logoUrl}
      alt={systemName}
      className={`${rounded ? "rounded-md" : ""} object-cover ring-1 ring-border ${className}`}
      style={{ height: size, width: size }}
    />
  );
}